import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppModesEnum } from 'src/app/models/WebServer/appModesEnum';
import { MediaTypesEnum } from 'src/app/models/WebServer/mediaTypesEnum';
import { Message } from 'src/app/models/WebServer/message';
import { AppConfigService } from 'src/app/services/app.config.service';
import { RootState } from 'src/app/store/root.state';

import { FileCategory, FileIconResult } from 'src/app/pipes/textMessageIcon.pipe';
import { TextTranslationService } from 'src/app/services/textTranslation.service';
import { MediaPreviewDialogComponent } from '../dialogs/media-preview-dialog.component';


@Component({
  selector: 'app-chat-preview',
  templateUrl: './chat-preview.component.html',
  styleUrls: ['./chat-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush // Ottimizzazione: check solo quando input cambiano
})
export class ChatPreviewComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() disabled!: boolean;
  @Input() message!: Message;
  @Input() fileIconResult!: FileIconResult;

  FileCategory = FileCategory;
  MediaTypesEnum = MediaTypesEnum
  appModes = AppModesEnum;

  // Stato di caricamento per i diversi tipi di media
  mediaLoaded: boolean = false;


  constructor(
    private store: Store<RootState>,
    public config: AppConfigService,
    public textTranslationService: TextTranslationService,
    private dialog: MatDialog
  ) {


  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    console.log(`ngOndestroy chat-preview.component {messageId: ${this.message.rtpCallId} ${this.message.fileName}}`);
  }

  ngOnInit() {
  }

  onLoadImage(event: Event) {
    const img = event.target as HTMLImageElement;
    this.mediaLoaded = true;
    img.style.width = 'auto';
    img.style.height = 'auto';
  }

  onLoadVideo(event: Event) {
    // Note: Currently not used - videos show static preview to avoid downloading
    // heavy files until user explicitly clicks to open fullscreen
    this.mediaLoaded = true;
  }

  onLoadAudio(event: Event) {
    this.mediaLoaded = true;
  }

  openImagePreview(imageSrc: string) {
    this.openMediaPreview(imageSrc, FileCategory.Image);
  }

  openVideoPreview(videoSrc: string) {
    this.openMediaPreview(videoSrc, FileCategory.Video);
  }

  openAudioPreview(audioSrc: string) {
    this.openMediaPreview(audioSrc, FileCategory.Audio);
  }

  private openMediaPreview(mediaUrl: string, mediaType: FileCategory) {
    // if (this.disabled) {
    //   return;
    // }

    this.dialog.open(MediaPreviewDialogComponent, {
      data: {
        downloadEnabled: this.config.agencySettings.imgDownloadEnabled,
        mediaUrl: mediaUrl,
        mediaType: mediaType,
        fileName: this.message.fileName
      },
      panelClass: 'fullscreen-dialog',
      maxWidth: 'min(100dvw, 100vw)',
      maxHeight: 'min(100dvh, 100vh)',
      width: '100%',
      height: '100%'
    });
  }
}
